import {ssrSafeLocation} from '@github-ui/ssr-utils'

export function resolveFeedbackPath({
  feedbackPath,
  commentUrl,
  origin = ssrSafeLocation.origin,
}: {
  feedbackPath?: string
  commentUrl?: string
  origin?: string
}) {
  if (feedbackPath) return feedbackPath
  if (commentUrl) {
    const parsedPath = new URL(commentUrl, origin)
    parsedPath.hash = ''
    return `${parsedPath}/code_review_feedback`
  }

  throw new Error('missing feedbackPath and commentUrl')
}
